
























import { mapState } from "vuex";

import AsideMenu from "@/components/AsideMenu.vue";
import AsideRight from "@/components/AsideRight.vue";
import NavBar from "@/components/NavBar.vue";
import Overlay from "@/components/Overlay.vue";

import { Component, Vue, Watch } from "vue-property-decorator";
import { Tenant } from "@/interfaces/tenants";

@Component({
  computed: {
    ...mapState(["isOverlayVisible", "tenants"])
  },
  components: {
    NavBar,
    AsideMenu,
    Overlay,
    AsideRight
  }
})
export default class DashboardPage extends Vue {
  // Mapped from vuex
  isOverlayVisible!: boolean;
  tenants!: Tenant[];

  // Other Variables
  menuSecondary?: any = null;
  menuSecondaryLabel?: string | null = null;
  menuSecondaryIcon?: string | null = null;

  get menu() {
    const newMenu: any = [];

    this.tenants.forEach(tenant => {
      newMenu.push(tenant.name);

      const entries = [];
      entries.push({
        to: `/tenant/${tenant.tenant_id}`,
        label: "Übersicht",
        icon: "desktop-mac-dashboard",
        updateMark: false
      });

      entries.push({
        to: `/tenant/${tenant.tenant_id}/videos`,
        label: "Videos",
        icon: "library-video",
        updateMark: false
      });

      entries.push({
        to: `/tenant/${tenant.tenant_id}/users`,
        label: "User Verwalten",
        icon: "account",
        updateMark: false
      });

      entries.push({
        to: `/tenant/${tenant.tenant_id}/open_transfers`,
        label: "Überweisungen",
        icon: "bank",
        updateMark: false
      });

      // entries.push({
      //   to: `/tenant/${tenant.tenant_id}/photos`,
      //   label: "Fotos",
      //   icon: "image-multiple",
      //   updateMark: false
      // });
      //
      // entries.push({
      //   to: `/tenant/${tenant.tenant_id}/users`,
      //   label: "Users",
      //   icon: "account-multiple",
      //   updateMark: false
      // });
      //
      // entries.push({
      //   to: `/tenant/${tenant.tenant_id}/settings`,
      //   label: "Einstellungen",
      //   icon: "cogs",
      //   updateMark: false
      // });

      newMenu.push(entries);
    });
    return newMenu;
  }

  get menuBottom() {
    return [
      {
        to: "logout",
        icon: "logout",
        label: "Ausloggen",
        state: "info"
      }
    ];
  }

  // ************** TEMPLATE FUNCTIONS ****************//

  // Methods
  menuClick(item: any) {
    if (item.menuSecondary) {
      this.menuSecondary = item.menuSecondary;
      this.menuSecondaryLabel = item.menuSecondaryLabel
        ? item.menuSecondaryLabel
        : null;
      this.menuSecondaryIcon = item.menuSecondaryIcon
        ? item.menuSecondaryIcon
        : null;

      this.$store.commit("asideActiveForcedKeyToggle", item);
      this.$store.commit("overlayToggle", true);
    } else if (item.action && item.action === "logout") {
      this.$buefy.toast.open({
        message: "Log out clicked",
        type: "is-danger",
        queue: false
      });
    }
  }

  menuSecondaryCloseClick() {
    this.$store.commit("overlayToggle", false);
  }

  menuSecondaryClose() {
    this.menuSecondary = this.menuSecondaryLabel = this.menuSecondaryIcon = null;
    this.$store.commit("asideActiveForcedKeyToggle", null);
  }

  // Life-Cycle Hooks
  created() {
    this.$store.commit("user", {
      name: "John Doe",
      email: "john@example.com",
      avatar: "/data-sources/avatars/annie-spratt-121576-unsplash.jpg"
    });
  }

  // Watchers
  @Watch("isOverlayVisible")
  onIsOverlayVisibleChange(newValue: boolean) {
    console.log("newValue");
    if (!newValue) {
      this.menuSecondaryClose();
    }
  }
}
